import get from 'lodash.get';
import { OutputParametricSelector } from 'reselect';

import { AppState } from 'services/types';
import {
    CalibrationId,
    Calibration,
    CalibrationProps
} from 'services/equipmentSets/types';
import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';

import { selectSprayWorksheetCalibrationsKeyedById } from '../../../../selectors';

import { CalibrationPageProps } from './types';

const selectCalibrationId = (
    state: AppState,
    props: CalibrationProps
): CalibrationId => props.calibrationId;

const makeSelectCalibrationValue = <T extends keyof Calibration>(
    fieldName: T
): OutputParametricSelector<
    AppState,
    CalibrationPageProps,
    Calibration[T],
    (
        arg1: ReturnType<typeof selectSprayWorksheetCalibrationsKeyedById>,
        arg2: ReturnType<typeof selectCalibrationId>
    ) => Calibration[T]
> =>
    createDeepEqualSelector(
        selectSprayWorksheetCalibrationsKeyedById,
        selectCalibrationId,
        (calibrationsKeyedById, calibrationId) =>
            get(calibrationsKeyedById, [calibrationId, fieldName])
    );

export { selectCalibrationId, makeSelectCalibrationValue };
